export function formatARS(amount: number): string {
  return `$${amount.toLocaleString('es-AR')}`
}
